import { NgIf } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  Input,
  ViewEncapsulation,
} from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { FittersSandboxService } from '@sc/data-access-state-management';
import { IconComponent } from '../icon';

@Component({
  selector: 'sc-rating',
  styleUrls: ['./rating.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgIf, IconComponent, TranslateModule],
  template: `
    <div
      *ngIf="fittersSB.showGoogleReview(brandId)"
      class="sc-conf-display-google-reviews"
    >
      <div class="container sc-conf-rating-star">
        <sc-icon name="star"></sc-icon>
        <div class="value">
          <p>{{ rating || '-' }}</p>
        </div>
        <span class="total" *ngIf="showNumberRating">
          <p>
            {{
              'Fitter.customerReviewsNumber'
                | translate
                  : {
                      nb: numberRating || '0'
                    }
            }}
          </p>
        </span>
        <sc-icon name="google_logo"></sc-icon>
      </div>
      <div class="container sc-conf-rating-on-five">
        <sc-icon name="google_logo"></sc-icon>
        <div class="value">
          <p>{{ rating ? rating + '/5' : '-' }}</p>
        </div>
        <span class="total" *ngIf="showNumberRating">
          <p>
            {{
              'Fitter.customerReviewsNumber'
                | translate
                  : {
                      nb: numberRating || '0'
                    }
            }}
          </p>
        </span>
      </div>
    </div>
  `,
})
export class RatingComponent {
  @Input() rating: number;
  @Input() showNumberRating = false;
  @Input() numberRating: number;
  @Input() brandId?: string;
  constructor(public fittersSB: FittersSandboxService) {}
}
